'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    select: (0, _functional.getElement)('[data-module-select]', { context: el })
  };
  this.defaultValue = 12;
  this.allowedValues = [6, 12, 18, 24, 30, 36, 42, 48];

  this.els.select.addEventListener('change', function (event) {
    var value = event.target.value;

    value = Number(value);

    value = _this.allowedValues.includes(value) ? value : _this.defaultValue;

    _jquery2.default.ajax({
      type: 'POST',
      url: '/cart.js',
      data: {
        'attributes[pagination]': value
      },
      success: function success() {
        window.location.reload();
      },

      dataType: 'json'
    });
    // axios({
    //   url: '/cart.js',
    //   method: 'POST',
    //   data: {
    //     'attributes[pagination]': event.target.value
    //   },
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'X-Requested-With': 'XMLHttpRequest' /* XMLHttpRequest is ok too, it's case
    // insensitive */ }, withCredentials: 'same-origin' }) .then((a) => console.log(a))
  });
};

exports.default = _class;